module.exports = "<div class=\"form-group\" [ngClass]=\"{ 'invalid': isInvalid, 'valid': isValid, 'required': isRequired }\">\n    <ng-container *ngFor=\"let option of options\">\n        <label class=\"form-radio-label\">\n            <input  class=\"form-control\" type=\"radio\" [(ngModel)]=\"option.value\" [disabled]=\"option.disabled\">\n            <span>{{ option.label }}</span>\n        </label>\n    </ng-container>\n<div>"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/forms/radio-box/radio-box.component.html
// module id = 847
// module chunks = 0